// Copyright 2023, Alexander Nekrasov, All rights reserved.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SettingBase } from "./SettingBase";
var SettingBool = /** @class */ (function (_super) {
    __extends(SettingBool, _super);
    function SettingBool(domain, name, defaultValue) {
        var _this = _super.call(this, domain, name, "SettingBool") || this;
        _this.defaultValue = defaultValue;
        _this.actualValue = defaultValue;
        _this.pendingValue = undefined;
        return _this;
    }
    Object.defineProperty(SettingBool.prototype, "dirty", {
        get: function () {
            return this.pendingValue !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SettingBool.prototype, "value", {
        get: function () {
            return this.dirty ? this.pendingValue : this.actualValue;
        },
        enumerable: false,
        configurable: true
    });
    SettingBool.prototype.fromDBJson = function (data) {
        this.Reset(data[this.name]);
        this.MarkInitialized();
    };
    SettingBool.prototype.toDBJson = function (data) {
        if (this.pendingValue !== undefined) {
            data[this.name] = this.pendingValue;
        }
    };
    SettingBool.prototype.Revert = function () {
        this.pendingValue = undefined;
    };
    SettingBool.prototype.Reset = function (value) {
        this.actualValue = value === undefined ? this.defaultValue : value;
        this.pendingValue = undefined;
    };
    SettingBool.prototype.SetValue = function (value) {
        var isActual = value === this.actualValue;
        this.pendingValue = isActual ? undefined : value;
    };
    return SettingBool;
}(SettingBase));
export { SettingBool };
